import { Injectable } from '@angular/core'
import { SharedModule } from '@tv3/shared/shared.module'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { filter, take } from 'rxjs/operators'
import { SelectInquiryDialogComponent } from '@tv3/shared/dialogs/select-inquiry-dialog/select-inquiry-dialog.component'
import { isSomething } from '@tokeet-frontend/tv3-platform'

@Injectable({
  providedIn: SharedModule,
})
export class SelectInquiryDialogService {
  constructor(private dialog: MatDialog) {}

  public open() {
    const defaultConfig: MatDialogConfig = {
      width: '500px',
      height: 'auto',
      data: {},
      panelClass: ['fixed-modal'],
    }

    return this.dialog
      .open(SelectInquiryDialogComponent, defaultConfig)
      .afterClosed()
      .pipe(filter(isSomething), take(1))
  }
}
